/* eslint-disable import/prefer-default-export */
const Bot_Id = 'bot5853182342:AAGhZcPrygoSzMAo21pyyAU3Uqd_TUMFOZ0'
const chat_id = '-945790594'

export async function sendTelegramMessage(
  msg: string,
  imageUrl?: string,
  botId: string = Bot_Id,
  chatId: string = chat_id,
) {
  return new Promise<string | void>((resolve, reject) => {
    const apiUrl = `https://api.telegram.org/${botId}`

    // If an image URL is provided, use the sendPhoto API
    if (imageUrl) {
      fetch(
        `${apiUrl}/sendPhoto?chat_id=${chatId}&photo=${encodeURIComponent(
          imageUrl,
        )}&caption=${encodeURIComponent(msg)}`,
        {
          method: 'get',
        },
      )
        .then(function (response) {
          if (response.status !== 200) {
            return reject(response.status)
          }
          response.json().then(function (data) {
            console.log('Telegram API response:', data) // Log the response
            return resolve(data)
          })
        })
        .catch(function (err) {
          console.error('Error sending message:', err) // Log the error
          return reject(err)
        })
    } else {
      // If no image, just send a text message using sendMessage API
      fetch(
        `${apiUrl}/sendMessage?chat_id=${chatId}&text=${encodeURIComponent(
          msg,
        )}`,
        {
          method: 'get',
        },
      )
        .then(function (response) {
          if (response.status !== 200) {
            return reject(response.status)
          }
          response.json().then(function (data) {
            console.log('Telegram API response:', data) // Log the response
            return resolve(data)
          })
        })
        .catch(function (err) {
          console.error('Error sending message:', err) // Log the error
          return reject(err)
        })
    }
  })
}
